/* eslint-disable arrow-body-style */
import React, { useContext, useState } from 'react';
import { useForm } from 'react-hook-form';

import { Button, Checkbox } from 'Profile/components';
import { useTranslation } from 'hooks';
import { MediaContext } from 'contexts/MediaContext';
import ToggleBlock from 'Profile/components/TransportationAmenities/ToggleBlock';

export default function ReasonForStay({
	stayReasons,
	selectedStayReasonIds,
	comments,
	onCheckboxChange,
	onCommentsChange,
	onGoBack,
	onSubmit,
}) {
	const { t } = useTranslation();

	const media = useContext(MediaContext);

	const [toggleBlockState, setToggleBlockState] = useState(null);

	const { register, handleSubmit } = useForm({
		defaultValues: selectedStayReasonIds,
	});

	const checkboxCategories = {
		leisure: {
			icon: '/images/profiles_2018/beach-icon.svg',
			displayName: 'Leisure',
		},
		special_occasion: {
			icon: '/images/profiles_2018/wedding-icon.svg',
			displayName: 'Celebration',
		},
		business: {
			icon: '/images/profiles_2018/business-laptop-icon.svg',
			displayName: 'Business',
		},
	};

	const checkedCount = selectedStayReasonIds.length;

	return (
		<form onSubmit={handleSubmit(onSubmit)} className="fs-trip__arrival-details__occasion-form">
			{media.isLessThan.scssLg ? (
				stayReasons.map(({ reasonType, options }) => {
					return (
						<ToggleBlock
							key={reasonType}
							title={
								<div className="arrival-amenities__category-title">
									<h4 className="ty-c1">{t(checkboxCategories[reasonType].displayName)}</h4>
								</div>
							}
							groupControlledToggle={toggleBlockState === reasonType}
							groupController={value => setToggleBlockState(value ? reasonType : null)}
							iconStyle="solid"
						>
							<div className="fs-trip__arrival-details__occasion-form__checkboxes">
								{options.map(({ id, displayName }) => (
									<Checkbox
										key={id}
										name={id}
										checked={selectedStayReasonIds.includes(id)}
										label={displayName}
										onChange={onCheckboxChange}
									>
										{t(displayName)}
									</Checkbox>
								))}
							</div>
						</ToggleBlock>
					);
				})
			) : (
				<div className="fs-trip__arrival-details__occasion-form__checkboxes">
					{stayReasons.map(({ reasonType, options }) => {
						return (
							<div
								key={reasonType}
								className="fs-trip__arrival-details__occasion-form__checkboxes__col"
							>
								<div className="fs-trip__arrival-details__occasion-form__checkboxes__col__header ty-c3">
									<img src={checkboxCategories[reasonType].icon} alt="" />
									{t(checkboxCategories[reasonType].displayName)}
								</div>
								{options.map(({ id, displayName }) => {
									return (
										<Checkbox
											key={id}
											name={id}
											checked={selectedStayReasonIds.includes(id)}
											label={displayName}
											onChange={onCheckboxChange}
										>
											{t(displayName)}
										</Checkbox>
									);
								})}
							</div>
						);
					})}
				</div>
			)}

			{((media.isLessThan.scssLg && (checkedCount > 0 || comments)) ||
				media.isGreaterThan.scssLg) && (
				<div className="fs-trip__arrival-details__occasion-form__textarea">
					<label htmlFor="comments" className="ty-c4">
						{t('Special Notes')}
					</label>
					<textarea
						className="fs-trip__text_area"
						name="comments"
						value={comments}
						placeholder={t(
							'Let us know of more details and we can arrange a special arrival for the occasion. '
						)}
						maxLength={200}
						onChange={e => onCommentsChange(e.target.value)}
						ref={register()}
					/>
				</div>
			)}

			<div className="fs-trip__arrival-details__btns">
				{onGoBack ? (
					<>
						<Button type="button" kind="secondary" onClick={onGoBack} aria-label="">
							{t('Back')}
						</Button>
						<Button type="submit" className="CTA--secondary--dark" aria-label="">
							{t('Next')}
						</Button>
					</>
				) : (
					<Button type="submit" className="CTA--secondary--dark" aria-label="">
						{t('Update')}
					</Button>
				)}
			</div>
		</form>
	);
}
